import React, { useState, useEffect } from 'react';
import { Row, Form, Button, Alert, Spinner, Col } from 'react-bootstrap';
import { postHealthCheck } from '../../../firebase-config';

function HealthCheckPage({ employee }) {
    useEffect(() => {
        document.title = "健康診断希望日申請";
    }, []);

    const [type, setType] = useState('健康診断');
    const [timeSlot, setTimeSlot] = useState('午前');
    const [date1, setDate1] = useState('');
    const [date2, setDate2] = useState('');
    const [date3, setDate3] = useState('');
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setShowSuccess(false);
        setShowError(false);

        try {
            await postHealthCheck(
                employee.id,
                employee.legechId,
                employee.slackMemberId,
                type,
                timeSlot,
                date1,
                date2,
                date3,
                note
            );
            setShowSuccess(true);
            setDate1('');
            setDate2('');
            setDate3('');
            setNote('');
        } catch (error) {
            setShowError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Row>
            <h1>健康診断希望日申請</h1>
            <p className="text-muted mt-2">
                昨年人間ドックを受けた場合は1年空けてください。<br />
                希望通りにならない可能性があります。念の為1日可能な日を申請してください。<br />
                <a href="https://docs.google.com/document/d/1LLhJQ2uCAOnAg_2Pxx7r-H63SwP-CgHX4VF8ClhLqRo/edit?tab=t.0" target="_blank" rel="noopener noreferrer">
                    健康診断について
                </a>
            </p>

            <Form onSubmit={handleSubmit} className='p-4'>
                <Row className='mb-4'>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label className='fw-bold'>種別 <span className='text-danger'>*</span></Form.Label>
                            <Form.Select value={type} onChange={e => setType(e.target.value)}>
                                <option value="健康診断">健康診断</option>
                                <option value="人間ドック">人間ドック</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col xs={6}>
                        <Form.Group>
                            <Form.Label className='fw-bold'>希望時間帯 <span className='text-danger'>*</span></Form.Label>
                            <Form.Select value={timeSlot} onChange={e => setTimeSlot(e.target.value)}>
                                <option value="午前">午前</option>
                                <option value="午後">午後</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>

                <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold'>第1希望日 <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        type='date'
                        value={date1}
                        onChange={e => setDate1(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold'>第2希望日 <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        type='date'
                        value={date2}
                        onChange={e => setDate2(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className='mb-3'>
                    <Form.Label className='fw-bold'>第3希望日 <span className='text-danger'>*</span></Form.Label>
                    <Form.Control
                        type='date'
                        value={date3}
                        onChange={e => setDate3(e.target.value)}
                        required
                    />
                </Form.Group>

                <Form.Group className='mb-4'>
                    <Form.Label className='fw-bold'>希望オプション</Form.Label>
                    <Form.Control
                        as='textarea'
                        rows={3}
                        maxLength={500}
                        value={note}
                        onChange={e => setNote(e.target.value)}
                        placeholder='任意'
                    />
                </Form.Group>

                <div className='d-grid gap-2'>
                    <Button variant='primary' type='submit' size='lg' disabled={loading}>
                        {loading ? '送信中...' : '申請する'}
                    </Button>
                    {loading && <Spinner animation='border' variant='dark' className='mx-auto' />}
                </div>
            </Form>

            {showSuccess && <Alert variant='success'>申請を送信しました。</Alert>}
            {showError && <Alert variant='danger'>送信に失敗しました。</Alert>}
        </Row>
    );
}

export default HealthCheckPage;
